import { render, staticRenderFns } from "./BillingInquiryVideo.vue?vue&type=template&id=63fb7742"
import script from "./BillingInquiryVideo.vue?vue&type=script&lang=js"
export * from "./BillingInquiryVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports